module["exports"] = [
  "Slovensko"
];



/*****************
 ** WEBPACK FOOTER
 ** ./~/faker/lib/locales/sk/address/default_country.js
 ** module id = 1016
 ** module chunks = 0
 **/